import { Capacitor, registerPlugin } from "@capacitor/core";

const plugin = registerPlugin("BankNotifications");

export const nativeBankNotifications = {
  available: () => Capacitor.getPlatform() === "android",
  status: () => plugin.status(),
  openAccessSettings: () => plugin.openAccessSettings(),
  configure: (enabled, packages) => plugin.configure({ enabled, packages }),
  pending: () => plugin.pending(),
  dismiss: (id) => plugin.dismiss({ id }),
  clearPending: () => plugin.clearPending(),
};
